import "../../sass/common/index.scss";
import "../../sass/adminCurrencies/index.scss";
import "../../sass/adminQbo/index.scss";
import "../../sass/adminTags/index.scss";
import "../../sass/adminImport/index.scss";
import "../../sass/adminSettings/index.scss";
import "../../sass/adminCache/index.scss";
import "../../sass/notification/index.scss";
import "../../sass/report/index.scss";
import "../../sass/sideMenu/index.scss";

// User account
import "../../sass/login/index.scss";
import "../../sass/forgotPassword/index.scss";
import "../../sass/forgotPasswordConfirmation/index.scss";
import "../../sass/register/index.scss";
import "../../sass/resetPassword/index.scss";
import "../../sass/resetPasswordConfirmation/index.scss";

// User
import "../../sass/user/index.scss";
import "../../sass/userAdd/index.scss";
import "../../sass/userEdit/index.scss";
import "../../sass/userPendingAccounts/index.scss";
import "../../sass/userRemoved/index.scss";

// Customer
import "../../sass/customer/index.scss";
import "../../sass/customerDetails/index.scss";
import "../../sass/CustomerSalesOrderIndex/index.scss";
import "../../sass/customerPayments/index.scss";
import "../../sass/customerNotes/index.scss";
import "../../sass/customerUploads/index.scss";

// Delivery
import "../../sass/delivery/index.scss";
import "../../sass/deliveryNew/index.scss";

// Return
import "../../sass/return/index.scss";
import "../../sass/returnDetails/index.scss";
import "../../sass/returnNew/index.scss";

// Sales order
import "../../sass/SalesOrder/index.scss";
import "../../sass/SalesOrderDetails/index.scss";
import "../../sass/SalesOrderAdviceNote/index.scss";
import "../../sass/invoice/index.scss";
import "../../sass/InvoiceDetails/index.scss";

// Supplier
import "../../sass/supplier/index.scss";
import "../../sass/supplierDashboard/index.scss";
import "../../sass/supplierDetails/index.scss";
import "../../sass/supplierNotes/index.scss";
import "../../sass/supplierPayments/index.scss";
import "../../sass/supplierPurchases/index.scss";
import "../../sass/supplierPurchaseOrder/index.scss";
import "../../sass/supplierEmailPurchaseOrder/index.scss";
import "../../sass/supplierViewPurchaseOrder/index.scss";
import "../../sass/supplierAdviceNotes/index.scss";
import "../../sass/supplierPurchaseOrderPdf/index.scss";
import "../../sass/supplierCreditNote/index.scss";

// Product
import "../../sass/productCategory/index.scss";
import "../../sass/productCategorySpecification/index.scss";
import "../../sass/productCategoryPrice/index.scss";
import "../../sass/product/index.scss";
import "../../sass/productDetails/index.scss";
import "../../sass/productNotes/index.scss";
import "../../sass/productPricingAndStock/index.scss";
import "../../sass/stockHistory/index.scss";

// Purchase
import "../../sass/purchase/index.scss";

// Generics
import "../../sass/genericList/index.scss";
import "../../sass/genericListItem/index.scss";
import "../../sass/currenciesEditor/index.scss";
import "../../sass/paymentMethod/index.scss";
import "../../sass/paymentMethodEditor/index.scss";

// Taxes
import "../../sass/tax/index.scss";
import "../../sass/taxEditor/index.scss";

// Plugin Settings
import "../../sass/plugins/index.scss";
import "../../sass/coreModules/index.scss";

// Warranty claim
import "../../sass/warrantyClaim/index.scss";
import "../../sass/warrantyClaimCustomer/index.scss";

// Credit Notes
import "../../sass/creditNote/index.scss";
import "../../sass/creditNoteCustomer/index.scss";
import "../../sass/creditNoteDetails/index.scss";

// Dynamic Form Builder
import "../../sass/dynamicFormBuilderEditor/index.scss";
import "../../sass/dynamicFormBuilder/index.scss";

// Services
import "../../sass/adminServices/index.scss";
import "../../sass/adminServicesEditor/index.scss";
